const de = {
  mte_management: 'MTE-Verwaltung',
  qr_code_reader: {
    no_front_camera: "Ihr Gerät scheint keine Frontkamera zu haben",
    no_rear_camera: "Ihr Gerät scheint keine Rückkamera zu haben",
    change_camera: "Kamera wechseln",
    error_permission: "FEHLER: Sie müssen die Kamerazugriffsberechtigung erteilen",
    error_no_camera: "FEHLER: Keine Kamera auf diesem Gerät",
    error_secure_context: "FEHLER: Sicherer Kontext erforderlich (HTTPS, localhost)",
    error_in_use: "FEHLER: Wird die Kamera bereits verwendet?",
    error_unsuitable: "FEHLER: Die installierten Kameras sind nicht geeignet",
    error_stream_api: "FEHLER: Stream API wird von diesem Browser nicht unterstützt",
    error_secure_context_detail: "FEHLER: Kamerazugriff ist nur in sicherem Kontext erlaubt. Verwenden Sie HTTPS oder localhost statt HTTP.",
    error_generic: "FEHLER: Kamerafehler ({errorName})",
    invalid_qr_code: "Ungültiger QR-Code: Keine gültige Auftrags-ID"
  },
  select_user_site: "Wählen Sie den Standort des neu zugewiesenen Benutzers aus",
  select_user_site_placeholder: "Benutzerstandort auswählen",
  select_user_reassign_placeholder: "Wählen Sie einen Benutzer aus, um die Aufträge neu zuzuweisen",
  qr_code_viewer: {
    close: "Schließen",
    error_exporting_traveler: "Fehler beim Exportieren der Laufkarte: {title} - {info}"
  },
  tasks_header: {
    options: "Optionen",
    progress: "Fortschritt",
    save_offline: "Offline speichern",
    sync_job: "Auftrag synchronisieren",
    documents: "Dokumente",
    copy_from: "Kopieren von",
    complete_job: "Auftrag abschließen",
    reopen_job: "Auftrag wieder öffnen",
    job_reopened_successfully: "Auftrag erfolgreich wieder geöffnet",
    failed_reopen_job: "Auftrag konnte nicht wieder geöffnet werden",
    complete_job_confirmation: "Einige Aufgaben wurden noch nicht abgezeichnet. Fortfahren und alle abschließen?",
    job_completed_notification: "Auftrag erfolgreich abgeschlossen. Benachrichtigung an {client} gesendet"
  },
  documents: "Dokumente",
  take_photo: "Foto aufnehmen",
  saved: "Gespeichert",
  rat_audit_ok: "Alle Teile in der RAT-Tabelle wurden einer Qualitätskontrolle unterzogen.",
  rat_audit_fail: "Einige Teile in der RAT-Tabelle wurden noch nicht einer Qualitätskontrolle unterzogen.",
  upload_rat: "RAT hochladen",
  forbidden_page: {
    message: 'Entschuldigung, Sie haben keine Berechtigung, diese Seite anzuzeigen.',
  },

  page_404: {
    message: '(404) Entschuldigung, diese Seite existiert nicht.',
    click: 'Klicken',
    here: 'hier',
    to_return: 'um zur Startseite zurückzukehren.',
  },

  login_page: {
    digital: 'Digital',
    inspection_jacket: 'Inspection Jacket',
    logging_in: 'Anmeldung läuft...',
  },

  dashboard_page: {
    welcome: 'Willkommen',
    intro: 'End-to-End-Lösung für die digitale Inspektion.',
    scan_project_code: 'Projektcode scannen',
    new_version_available: 'Neue Version verfügbar!',
    websocket_status: 'WebSocket-Status',
    dij_version: 'Digital Inspection Jacket {version}',
    job_checked_out_offline: 'Dieser Auftrag wurde für die Offline-Nutzung ausgecheckt.',
  },

  header: {
    app_name: 'Digital Inspection Jacket',
  },

  task_page: {
    create_new_task: 'Neue Aufgabe erstellen',
    back_to_product_list:
      'Wenn Sie hier fertig sind, gehen Sie bitte zurück zur Vorlagenliste, damit andere an dieser Vorlage arbeiten können',
    back_to_work_order_list:
      'Wenn Sie hier fertig sind, gehen Sie bitte zurück zur Arbeitsauftragsliste, damit andere an diesem Auftrag arbeiten können',
    drop_file_reference_image: 'Datei hier ablegen oder klicken, um ein Referenzbild hochzuladen',
    reference_image: 'Referenzbild',
    signed_off_by: 'Abgezeichnet von {name}',
    task_not_available_offline: 'Aufgabe ist offline nicht verfügbar',
    need_help_chat: 'Brauchen Sie Hilfe? Klicken Sie hier zum Chatten!',
    loading_user_roles: 'Benutzerrollen werden geladen...',
    loading_job_details: 'Auftragsdetails werden geladen...',
    checking_job_status: 'Auftragsstatus wird geprüft...',
    loading_job_tasks: 'Aufgaben werden geladen...',
    deleting_task: 'Aufgabe wird gelöscht...',
    duplicating_folder: 'Ordner wird dupliziert...',
    select_folder_to_move: 'Ordner zum Verschieben auswählen.',
    delete_folder_confirmation_message: 'Das Löschen eines Ordners löscht alle darin enthaltenen Aufgaben.',
    delete_confirmation: 'Sind Sie sicher, dass Sie löschen möchten?',
  },

  create_new_user_page: {
    create_new_user: 'Neuen Benutzer erstellen',
    create_user: 'Benutzer erstellen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    gid: 'GID',
    email: 'E-Mail',
    password: 'Passwort',
    role: 'Rolle',
    all_fields_required: 'Bitte füllen Sie alle erforderlichen Felder aus.',
    user_failed: 'Benutzererstellung fehlgeschlagen.',
    user_success: 'Benutzer wurde erfolgreich erstellt.',
    password_validation: 'Passwortanforderungen: mindestens 8 Zeichen, ein Kleinbuchstabe, ein Großbuchstabe, eine Zahl, keine Teile Ihres Benutzernamens.'
  },

  change_password_page: {
    change_password: 'Passwort ändern',
    change_user_password: 'Benutzerpasswort ändern',
    password_change_success: 'Passwort wurde erfolgreich geändert',
    secret_question_success: 'Sicherheitsfrage wurde erfolgreich gesetzt',
    password_change_fail: 'Passwort konnte nicht geändert werden.',
    secret_question_fail: 'Sicherheitsfrage konnte nicht gesetzt werden',
    email: 'E-Mail',
    oldPassword: 'Altes Passwort',
    password: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    password_should_match: 'Neues Passwort und bestätigtes Passwort müssen übereinstimmen.',
    password_validation: 'Passwortanforderungen: mindestens 8 Zeichen, ein Kleinbuchstabe, ein Großbuchstabe, eine Zahl, keine Teile Ihrer E-Mail.',
    passwordLowerCase: "Das Passwort muss mindestens einen Kleinbuchstaben enthalten.",
    passwordUpperCase: "Das Passwort muss mindestens einen Großbuchstaben enthalten.",
    passwordNumber: "Das Passwort muss mindestens eine Ziffer enthalten.",
    passwordMinLength: "Das Passwort muss mindestens 8 Zeichen lang sein.",
    passwordNoUsernameParts: "Das Passwort darf keine Teile des Benutzernamens enthalten."
  },

  profile_page: {
    myProfile: 'Mein Profil',
    account: 'Konto',
    preferences: 'Einstellungen',
    profileUpdated: 'Profil erfolgreich aktualisiert',
    updatePreferences: 'Einstellungen aktualisieren',
    updateAccount: 'Konto aktualisieren',
    my_name: 'Mein Name',
    username: 'Benutzername',
    email: 'E-Mail',
    location: 'Standort',
    phone_number: 'Telefonnummer',
    units: 'Einheiten',
    inches: 'Zoll',
    millimetres: 'Millimeter',
  },

  task_view: {
    cancel: 'Abbrechen',
    back: 'Zurück',
    save: 'Speichern',
    delete: 'Löschen',
    deleteConfirmation: 'Sind Sie sicher, dass Sie die Aufgabe <b>{taskTitle}</b> <b>löschen</b> möchten?',
    deleteTask: 'Aufgabe löschen',
    manageMte: 'Instrumentierungsprotokoll',
    repairAssessment: 'Reparaturbewertung',
    importAccuScan: 'AccuScan importieren',
    importLaserscan: 'Laserscan importieren',
    signOff: 'Abzeichnen',
    orderItem: 'Bestellartikel'
  },

  text_size: 'Textgröße',
  selection: 'Auswahl',
  alignedlength: 'Ausgerichtete Länge',
  linearlength: 'Lineare Länge',
  positive_tolerance: '+ Toleranz',
  negative_tolerance: '- Toleranz',

  product_template_list: 'Produktvorlagenliste',
  work_order_list: 'Arbeitsauftragsliste',
  update: 'Aktualisieren',
  order: 'Reihenfolge',
  select_folder: 'Ordner auswählen',
  move: 'Verschieben',
  add_task: 'Aufgabe hinzufügen',
  add_folder: 'Ordner hinzufügen',
  add_field: 'Feld hinzufügen',
  message_order_drag: 'Jetzt können Sie Ihre Aufgaben sortieren, einfach ziehen',
  move_folder: 'In Ordner verschieben',
  move_selected: 'Auswahl verschieben',
  select: 'Auswählen',
  delete_selected: 'Auswahl löschen',

  admin: 'Administrator',
  editor: 'Bearbeiter',
  publisher: 'Herausgeber',
  inspector: 'Inspektor',
  report: 'Bericht',
  dashboard: 'Dashboard',
  profile: 'Profil',
  language: 'Sprache',
  view_profile: 'Profil anzeigen',
  manage_fleet_data: 'Flottendaten verwalten',
  report_issue: 'Problem melden',
  request_content: 'Inhalt anfordern',
  contact_us: 'Kontakt',
  forum: 'Viva Engage Forum',
  training: 'Training',
  log_out: 'Abmelden',

  choose_language: 'Wählen Sie Ihre bevorzugte Sprache.',

  create_new_product: 'Neues Produkt erstellen',
  task: 'Aufgabe',
  font_size: 'Schriftgröße',
  title: 'Titel',
  product_line: 'Produktlinie',
  original_OEM: 'Original OEM',
  original_oem: 'Original OEM',
  brand: 'Marke',
  frame_type: 'Rahmentyp',
  model: 'Modell',
  choose_files: 'Dateien auswählen',
  ocr: 'OCR',
  part_number: 'Teilenummer',
  document_number: 'Dokumentnummer',
  revision: 'Revision',
  cancel: 'Abbrechen',
  submit: 'Absenden',
  delete: 'Löschen',
  save: 'Speichern',
  done: 'Fertig',
  new_product_success: 'Neues Produkt erfolgreich erstellt.',
  new_order_success: 'Neuer Auftrag erfolgreich erstellt!',
  new_product_fail_message: 'Fehler beim Erstellen des neuen Auftrags! Bitte erneut versuchen.',
  new_order_fail_message: 'Fehler beim Erstellen des neuen Auftrags! Bitte erneut versuchen.',
  select_sites: 'Standorte auswählen',
  product_created_success: 'Produkt erfolgreich erstellt!',
  product_updated_success: 'Produkt erfolgreich aktualisiert!',
  template: 'Vorlage',
  configuration: 'Konfiguration',
  sales_force_opportunity_number: 'Sales Force Opportunity-Nummer',
  select_all_limit_tooltip: 'Die Schaltfläche "Alle auswählen" fügt 15 Vorlagen hinzu (Limit)',
  select_all: 'Alle auswählen',
  deselect_all: 'Alle abwählen',
  select_everything: 'Alles auswählen',
  deselect_everything: 'Alles abwählen',
  import_limit_message: 'Es wurden nur 15 Vorlagen importiert, das Limit wurde erreicht.',
  sorting_gmtl: 'Sortierung gemäß GMTL',

  // Tool names inside diagram
  'Selection Tool': 'Auswahlwerkzeug',
  'Pan Viewport': 'Ansicht verschieben',
  'Diameter': 'Durchmesser',
  'Run-Out': 'Rundlauffehler',
  'Linear Length': 'Lineare Länge',
  'Visual Inspection': 'Sichtprüfung',
  'Text': 'Text',
  'Generic Measurement': 'Allgemeine Messung',
  'Arrow': 'Pfeil',
  'Line': 'Linie',
  'Replace Image': 'Bild ersetzen',

  // Bubble names
  generic: 'Allgemeiner Marker',
  generic_name: 'Allgemeiner Name',
  runout: 'Rundlauffehler',
  length: 'Länge',
  diameter: 'Durchmesser',
  arrow: 'Pfeil',
  line: 'Linie',
  text: 'Text',
  table: 'Tabelle',
  replace: 'Bild ersetzen',
  visualInspection: 'Sichtprüfung',
  visual: 'Sichtprüfung',
  'position-image': 'Bild positionieren',
  'alignedLength': 'Ausgerichtete Länge',
  'linearLength': 'Lineare Länge',

  // Bubble properties
  label_numbers_only: 'Bezeichnung (nur Zahlen)',
  expected_value: 'Erwarteter Wert',
  decimals: 'Dezimalstellen',
  units: 'Einheiten',
  inch: 'Zoll',
  mm: 'mm',
  tolerance_type: 'Toleranztyp',
  tolerance: 'Toleranz',
  multiple_positions: 'Mehrere Positionen',
  edit_table: 'Tabelle bearbeiten',
  orientation: 'Ausrichtung',
  measurement_name: 'Messungsname',
  visual_name: 'Sichtprüfungsname',
  marker_description: 'Beschreibung',
  generic_marker_tolerance: 'Toleranz',
  direction: 'Richtung',
  degrees: 'Grad',
  clock: 'Uhr',
  rotate_text: 'Text drehen',
  rubbed: 'Gerieben',
  damaged: 'Beschädigt',
  pitted: 'Korrodiert',
  eroded: 'Erodiert',
  high: 'Hoch',
  low: 'Niedrig',
  medium: 'Mittel',
  acceptable: 'Akzeptabel',
  all: 'Alle',
  position: 'Position',
  tir: 'TIR',
  ok: 'Ok',
  in: 'Zoll',
  iso_name: 'ISO',
  iso_grade: 'ISO-Klasse',
  RAT: 'RAT',
  none: 'Keine',

  // Save or discard dialog
  save_or_discard_dialog_content: 'Möchten Sie Ihre Änderungen speichern?',
  discard: 'Verwerfen',
  stay: 'Bleiben',
  back: 'Zurück',
  dismiss: 'Schließen',

  import_drawing: 'Zeichnung importieren',
  work_order_list: 'Arbeitsauftragsliste',

  edit_name: 'Name bearbeiten',
  reopen: 'Wieder öffnen',

  //Instruction actions
  create_new_item: 'Neues Element erstellen',
  choose_one_item: ' Ein Element auswählen',
  order_item: 'Element bestellen',
  action: 'Aktion',
  yes_no: 'Ja/Nein',
  options: 'Option',
  add_iso: 'ISO hinzufügen',
  add_calculation: 'Berechnung hinzufügen',
  recover: 'Wiederherstellen',
  loading: 'Wird geladen...',
  clear_filters: 'Filter löschen',
  job_downloaded_locally: 'Auftrag lokal heruntergeladen',
  job_has_incomplete_data: 'Auftrag hat unvollständige Daten',
  job_includes_repair_assessment: 'Dieser Auftrag enthält Reparaturbewertungen',
  text: 'Text',
  sap_reference: 'SAP-Referenz',
  filter: 'Filter',
  current_owner: 'Aktueller Eigentümer',
  current_owner_date: 'Aktueller Eigentümer / Datum',

  template_list: {
    retrieving_listings: 'Einträge werden basierend auf Ihrer Suche abgerufen...',
    fetched_pages_found: 'Bisher {batchCount} Seiten abgerufen. {size} Einträge gefunden...',
    found_listings: '{length} Einträge gefunden, die den Suchkriterien entsprechen.',
    failed_to_fetch_listings: 'Einträge konnten nicht abgerufen werden',
    loading_list: 'Lade {listName}...',
    loading_list_progress: 'Lade {listName}... ({processedCount}/{total})',
    loaded_list: '{listName} geladen',
    loading_job: 'Auftrag wird geladen...',
    next_page: 'Nächste Seite',
    previous_page: 'Vorherige Seite',
    page_label: 'Seite',
    current_page: 'Aktuelle Seite',
    csm_repair_engineer: 'CSM / Reparaturingenieur',
    warning: "Warnung",
    repair_select_assistant: "Repair Select-Assistent",
    how_can_i_help: "Wie kann ich helfen?",
    no_results_clear_filters: "Die Suche hat keine Ergebnisse geliefert. Filter löschen, um Daten zu erhalten.",
    checked_out_by: "Ausgecheckt von {user}",
    completeness: "Vollständigkeit: {percentage}%",
    delete_confirmation_title: "LÖSCHEN",
    delete_confirmation_message: "Bitte bestätigen Sie das Löschen von {title}",
    delete_confirm_button: "Löschen",
    max_favorites_warning: "Sie können maximal 140 Favoriten hinzufügen.",
    job_needs_sync: "Auftrag hat Daten, die synchronisiert werden müssen"
  },

  languages: {
    en: 'Englisch',
    de: 'Deutsch',
    pt: 'Portugiesisch',
    it: 'Italienisch',
  },

  copy_from_page: {
    copy_from: "Kopieren von",
    copying_tasks_to: "Aufgaben werden nach \"{title}\" kopiert",
    publisher_tasks: "Herausgeber-Aufgaben",
    editor_tasks: "Bearbeiter-Aufgaben",
    search: "Suchen...",
    select_all_limit_tooltip: "Die Schaltfläche 'Alle auswählen' fügt 30 Aufgaben hinzu (Limit)",
    select_site: "Standort auswählen",
    doc_no: "Dok.-Nr.",
    sorting_gmtl_tooltip: "Sortierung gemäß GMTL",
    work_order: "Arbeitsauftrag",
    duplicated_task: "Duplizierte Aufgabe",
    task_already_selected: "Aufgabe '{name}' ist bereits ausgewählt",
    limit_reached: "Es wurden nur {limit} Aufgaben importiert, das Limit wurde erreicht. Die letzte Vorlage, von der Aufgaben geholt wurden, war: {title}"
  },

  table: 'Tabelle',
  import_csv: 'CSV importieren',

  action_requested: 'Aktion erforderlich',
  picture_taken_is_mandatory: 'Ein aufgenommenes Bild ist erforderlich.',
  picture_uploaded_successfully: '{image} erfolgreich hochgeladen',
  picture_required: 'Bild erforderlich.',
  your_question: 'Ihre Frage',
  question: 'Frage',
  options: 'Option',
  add_an_option: 'Option hinzufügen',
  multiple_choice: 'Mehrfachauswahl',
  single_choice: 'Einzelauswahl',
  text_or_number: 'Text oder Zahl',

  number_of_rows: 'Anzahl der Zeilen',
  number_of_columns: 'Anzahl der Spalten',
  edit_rows: 'Zeilen bearbeiten',
  edit_columns: 'Spalten bearbeiten',
  only_numbers_and_alphabets: 'In einer Zelle sind nur Zahlen und Buchstaben bis zu 16 Zeichen erlaubt',
  table_headings_not_empty: 'Tabellenüberschriften dürfen nicht leer sein',
  upload_diagram: 'Diagramm hochladen',

  yes: 'Ja',
  no: 'Nein',

  product_template_list: 'Produktvorlagenliste',
  product_line: 'Produktlinie',
  work_order_list: 'Arbeitsauftragsliste',
  favorite_list: 'Favoritenliste',
  search: 'Suchen',
  search_ellipsis: 'Suchen...',
  add_product: 'Produkt hinzufügen',
  title: 'Titel',
  original_OEM: 'Original OEM',
  frame_type: 'Rahmentyp',
  model: 'Modell',
  part_number: 'Teilenummer',
  location: 'Standort',
  document_number: 'Dokumentnummer',
  revision: 'Revision',
  created_by: 'Erstellt von',
  date: 'Datum',
  add: 'Hinzufügen',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  duplicate: 'Duplizieren',
  copyfrom: 'Kopieren von',
  nothing_here: 'Nichts vorhanden',

  project_number: 'Projektnummer',
  customer: 'Kunde',
  work_order_number: 'Arbeitsauftragsnummer',
  serial_number: 'Seriennummer',
  sales_force_number: 'Sales Force-Nummer',
  add_order: 'Auftrag hinzufügen',
  edit_order: 'Auftrag bearbeiten',
  original_oem_number: 'Original OEM-Nummer',
  freefinding: 'Freier Befund',
  csm_label: 'Client Service Manager (CSM) / Projektmanager',
  repair_engineer_label: 'Reparaturingenieur / Projektingenieur',

  part_level: 'Teileebene',
  ignore: 'Ignorieren',
  component: 'Komponente',
  crop_image: 'Bild zuschneiden',
  create_rat: 'RAT erstellen',
  major: 'Haupt',
  minor: 'Unter',
  select_page: 'Seite {currentPage} von {totalPages} auswählen',

  new_product_success_message: 'Neues Produkt erfolgreich erstellt!',
  new_product_fail_message: 'Fehler beim Erstellen des neuen Auftrags! Bitte erneut versuchen.',

  task_count: 'Aufgabenanzahl',
  selection_from_list: 'Bei Bedarf eine Auswahl aus der Liste treffen',
  select_tasks: 'Aufgaben auswählen',
  select_products: 'Produkte auswählen (Optional)',

  select_all: 'Alle auswählen',
  deselect_all: 'Alle abwählen',
  select_site: 'Standort auswählen',
  selected_products: 'Ausgewählte Produkte',
  review: 'Überprüfen',
  sites: 'Sekundäre Standorte',
  primary: 'Primär',
  secondary: 'Sekundär',
  products: 'Produkte',
  tasks: 'Aufgaben',
  next: 'Weiter',

  sign_off: 'Abzeichnen',
  sign_off_questions_completed: '{completed}/{total} abgeschlossen.',
  sign_off_diagram_completed: 'Diagramm {percent}% abgeschlossen.',
  sign_off_comments_label: 'Bitte geben Sie hier Ihre Kommentare ein...',
  number_of_measurement_points: 'Anzahl der Messpunkte',
  stage: 'Stufe',
  number_of_stages: 'Anzahl der Stufen',
  add_job_with_table_message: 'Entschuldigung, Sie können keine neuen Aufträge hinzufügen, da Sie einen Auftrag mit einer Aufgabentabelle ausgewählt haben.',
  configure_table_order: 'Tabelle konfigurieren',
  no_options_part_level: 'Keine Optionen gefunden. Wenn Sie eine erstellen möchten, geben Sie "Andere" ein und wählen aus.',
  all_configurations_done: 'Alle Konfigurationen in diesem Auftrag abgeschlossen',
  finish_configuration: 'Diese Konfiguration abschließen',
  configured_jobs: 'Konfigurierte Aufträge',
  version: 'Version',
  task_completed_message: 'Aufgabe bereits abgezeichnet! Bitte erneut öffnen für weitere Änderungen!',

  create_task: {
    create_new_task: 'Neue Aufgabe erstellen',
    diagram: 'Diagramm',
    instruction: 'Anweisung',
    worksheet: 'Arbeitsblatt',
    task_name: 'Aufgabenname',
    cancel: 'Abbrechen',
    done: 'Fertig',
    select_software_tool: 'Softwaretool wählen',
  },

  create_folder: {
    create_new_folder: 'Neuen Ordner erstellen',
    folder_name: 'Ordnername',
    select_software_tool: 'Softwaretool wählen',
    configure_new_part: 'Neues Teil konfigurieren',
    draw_no_b_plan: 'Zeichnungs-Nr. (B-Plan)',
    draw_no: 'Zeichnungs-Nr.',
    rotor_id: 'Rotor-ID',
    parts_list: 'Teileliste',
    hallmark: 'Kennzeichen',
    delete_title: 'LÖSCHEN',
    delete_field_confirmation: 'Feld {label} löschen?',
    name_prompt: 'Name',
    field_already_exists: 'Feld existiert bereits.',
    failed_create_task: 'Neue Aufgabe konnte nicht erstellt werden',
    start_of_stages: 'Beginn der Stufen',
    end_of_stages: 'Ende der Stufen',
  },

  emfProductList: {
    'workOrderList': 'Arbeitsauftragsliste',
    'search': 'Suchen',
    'addOrder': 'Auftrag hinzufügen',
    'next': 'Weiter',
    'previous': 'Zurück',

    'productLine': 'Produktlinie',
    'title': 'Titel',
    'originalOEM': 'Original OEM',
    'frameType': 'Rahmentyp',
    'model': 'Modell',
    'partNumber': 'Teilenummer',
    'customer': 'Kunde',
    'projectNumber': 'Projektnr.',
    'serialNumber': 'Seriennr.',
    'workOrder': 'Arbeitsauftrag',
    'salesForce': 'Sales Force Opportunity-Nr.',
    'createdBy': 'Erstellt von',
  },

  loginSession: {
    'admin': 'Administrator',
    'editor': 'Bearbeiter',
    'publisher': 'Herausgeber',
    'inspector': 'Inspektor',
    'report': 'Bericht',
    'dashboard': 'Dashboard',
    'language': 'Sprache',
    'profile': 'Profil',
    'viewProfile': 'Profil anzeigen',
    'manageFleetData': 'Flottendaten verwalten',
    'reportIssue': 'Problem melden',
    'requestContent': 'Inhalt anfordern',
    'contactUs': 'Kontakt',
    'training': 'Training',
    'logOut': 'Abmelden'
  },

  404: 'Nicht gefunden',

  table_template: {
    create_table: 'Tabelle erstellen',
    new_column: 'Neue Spalte hinzufügen',
    new_row: 'Neue Zeile hinzufügen',
    delete_column: 'Ausgewählte Spalte löschen',
    delete_row: 'Ausgewählte Zeile löschen'
  },

  calculation: {
    sum: 'Summe',
    sub: 'Subtrahieren',
    mult: 'Multiplizieren'
  },

  duplicate_work_order_number: 'Die angegebene Arbeitsauftragsnummer wird bereits verwendet',
  view_qr_code: 'QR-Code anzeigen',
  download_qr_code: 'QR-Code herunterladen',
  download_traveler: 'Reisedokument herunterladen',
  include_repair_assessment: 'Reparaturbewertung einschließen',
  repair_assessment: 'Reparaturbewertung',
  import: 'Importieren',
  import_editor_template: 'Vorhandene Vorlagen',
  import_add_excel_file: 'Aus Excel-Datei hinzufügen',
  download_excel_file: 'Vorlagendatei herunterladen',
  export_task: 'Aufgabe exportieren',
  saved: 'Gespeichert',
  not_saved: 'Nicht gespeichert',
  level: 'Ebene',
  assembly: 'Baugruppe',
  item_number: 'Positionsnummer',
  part_name: 'Teilename',
  part_number: 'Teilenummer',
  quantity: 'Menge',
  serialNumber: 'Seriennummer',
  actions: 'Aktionen',
  no_records: 'Keine Einträge',
  repair_assessment_empty: 'Die Reparaturbewertung ist leer. Beginnen Sie mit dem Import von Daten oder der manuellen Eingabe',
  repair_assessment_empty_readonly: 'Die Reparaturbewertung ist leer.',
  close: 'Schließen',
  close_notification: 'Benachrichtigung schließen',
  import_add: 'Importieren',
  change_log: 'Änderungsprotokoll',

  add_row: 'Zeile hinzufügen',
  remove_row: 'Zeile entfernen',

  repair_assessment_excel_import_failed: 'Reparaturbewertung konnte nicht aus der Excel-Datei importiert werden',

  reuse: 'Wiederverwenden',
  repair: 'Reparieren',
  replace: 'Ersetzen',
  missing: 'Fehlend',
  client_reject: 'Kundenablehnung',
  received: 'Erhalten',
  quality_control_override: 'QK',
  reviewed: 'Ing.-Prüfung',
  comments: 'Kommentare',

  findings: 'Befunde',
  recommendations: 'Empfehlungen',

  visual: 'Visuell',
  dim: 'Abmessung',
  ndt: 'ZfP',

  summary: 'Zusammenfassung',
  repair_scope: 'Reparaturumfang',
  estimated_labor: 'Gesch. Stunden',

  not_repair_engineer: 'Nur Ingenieure dürfen überprüfen',

  pre_assembly_audit: 'Vormontagekontrolle',
  donwload_rat: 'Komponenten exportieren',
  repair_assessment_search_empty: 'Keine Elemente verfügbar.',

  delete_all: 'Alle löschen',
  delete_all_message: 'Dadurch werden alle Informationen zur Reparaturbewertung gelöscht.',
  delete_major_message: 'Dadurch werden die Informationen zu Hauptkomponenten der Reparaturbewertung gelöscht.',
  delete_minor_message: 'Dadurch werden die Informationen zu Unterkomponenten der Reparaturbewertung gelöscht.',

  repair_assessment_row_locked: 'Diese Zeile ist gesperrt von {user}',

  feature_disabled: 'Diese Funktion ist an Ihrem Standort deaktiviert',

  locations: 'Standorte',

  recycle_bin: 'Papierkorb',
  recycle_bin_empty: 'Der Papierkorb ist leer',

  task_name: 'Name',
  task_type: 'Typ',
  deleted_by: 'Gelöscht von',
  deleted_at: 'Gelöscht am',

  executing_site: 'Ausführender Standort',

  na: 'N/V',

  owner: 'Eigentümer',

  mtetype_create_title: 'MTE-Typ erstellen',
  mtetype_update_title: 'MTE-Typ aktualisieren',

  create: 'Erstellen',

  name: 'Name',
  needs_master: 'Benötigt Master',
  is_master: 'Ist Master',

  mte_type_delete_question: 'Sind Sie sicher, dass Sie diesen MTE-Typ löschen möchten?',
  mte_type_delete_success: 'MTE-Typ erfolgreich gelöscht',
  mte_type_delete_fail: 'MTE-Typ konnte nicht gelöscht werden',

  mte_management: 'Instrumentierungsprotokoll',
  add_using_camera: 'Per Kamera hinzufügen',
  close_camera: 'Kamera schließen',
  add_manual_entry: 'Manuellen Eintrag hinzufügen',
  create_external_link: 'Klicken, um Datei/Link hinzuzufügen',
  select_file_to_link: 'Wählen Sie eine Datei, um sie der Aufgabe zuzuordnen',

  id: 'ID',
  type: 'Typ',
  due_date: 'Fälligkeitsdatum',
  master: 'Master',
  created_at: 'Erstellt am',

  masters: 'Master',
  non_masters: 'Andere',

  mandatory_error_message: '{field} ist erforderlich',
  mandatory_date_must_not_be_in_past_error_message: '{field} ist erforderlich und darf nicht in der Vergangenheit liegen',
  unique_error_message: '{field} muss eindeutig sein',

  task_locked_by_user: 'Aufgabe ist gesperrt von {user} bis {date}',

  clear: 'Löschen',
  surrogate: 'Stellvertreter',
  stop_surrogating: 'Stellvertretung beenden',

  create_new_site_page:
  {
    siteName: 'Standortname',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    create_new_site: 'Neuen Standort erstellen',
    all_fields_required: 'Bitte füllen Sie alle erforderlichen Felder aus.',
    site_failed: 'Standorterstellung fehlgeschlagen.',
    site_success: 'Standort erfolgreich erstellt.',
  },

  edit_site_page:
  {
    edit_site: 'Standort bearbeiten',
    siteName: 'Standortname',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    rat: 'Reparaturbewertungsvorlage',
    mte_m: 'Instrumentierungsprotokoll',
    delete: 'Löschen',
    update: 'Aktualisieren',
    successMessage: 'Standort erfolgreich aktualisiert.',
    failedMessage: 'Standort konnte nicht aktualisiert werden.',
    delete_confirm: 'Sind Sie sicher, dass Sie diesen Standort löschen möchten?',
    deletesite: 'Standort erfolgreich gelöscht.',
    deletefail: 'Standort konnte nicht gelöscht werden.',
  },
  site_list:
  {
    siteName: 'Standortname',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    DateModified: 'Änderungsdatum'
  },
  announcement_banner:
  {
    title: 'Ankündigungsbanner',
    description: 'Ankündigungsbanner einrichten.',
    status: 'Status',
    message: 'Nachricht',
    start_date: 'Startdatum',
    end_date: 'Enddatum',
    clear_action: 'Löschen',
    preview_action: 'Vorschau',
    save_action: 'Speichern',
    enabled_status: 'Aktiviert',
    disabled_status: 'Deaktiviert',
    clear_question: 'Dadurch wird das Benachrichtigungsbanner für alle Benutzer deaktiviert. Fortfahren?',
    end_date_error: 'Das Enddatum muss in der Zukunft liegen'
  },
  edit_user_profile: {
    title: 'Benutzerprofil',
    user_owned_template_count: 'Dieser Benutzer ist Eigentümer von {count} Vorlagen',
    user_owned_job_count: 'Dieser Benutzer ist Eigentümer von {count} Aufträgen',
    reassign_jobs: 'Aufträge neu zuweisen',
    reassign_templates: 'Vorlagen neu zuweisen',
    reassign_jobs_cancel: 'Neuzuweisung abbrechen',
    reassign_job: 'Auftrag neu zuweisen',
    confirm_reassign: 'Neuzuweisung bestätigen',
    pending_approval_message: 'Dieser Benutzer wartet auf Genehmigung. Überprüfen Sie die Benutzerinformationen und genehmigen Sie das Profil, damit der Benutzer DIJ nutzen kann',
    rejected_message: 'Dieser Benutzer wurde abgelehnt und kann nicht auf DIJ zugreifen. Der Benutzer kann bei Bedarf noch genehmigt werden.',
    success_message: 'Benutzer erfolgreich aktualisiert',
    full_name: 'Vollständiger Name',
    email: 'E-Mail',
    primary_location: 'Primärer Standort',
    secondary_locations: 'Sekundäre Standorte',
    phone_number: 'Telefonnummer',
    role: 'Rolle',
    power_admin_role: 'Power-Administrator',
    placeholder_role: 'Rolle',
    ownership: 'Eigentümerschaft',
    additional_permissions: 'Zusätzliche Berechtigungen',
    enginner_review_permission: 'Ingenieurprüfung',
    delete_button: 'Löschen',
    update_button: 'Aktualisieren',
    approve_button: 'Genehmigen',
    reject_button: 'Ablehnen',
    cancel_button: 'Abbrechen',
    approve_question: 'Sie genehmigen jetzt den Benutzer {name} mit der Rolle \'{role}\' und den Standorten \'{locations}\'. Fortfahren?',
    reject_question: 'Sie lehnen jetzt {name} ab. Der Benutzer wird DIJ nicht verwenden können. Fortfahren?',
    approve_success_message: 'Der Benutzer wurde erfolgreich genehmigt',
    reject_success_message: 'Der Benutzer wurde erfolgreich abgelehnt',
    update_success_message: 'Die Benutzerinformationen wurden erfolgreich aktualisiert',
    job_reassignment_success_message: 'Die Vorlagen dieses Benutzers wurden erfolgreich neu zugewiesen',
  },
  new_user_welcome_page: {
    welcome_configurator_message: 'Willkommen bei DIJ. Bitte wählen Sie die für Ihre Arbeit relevanten Standorte aus',
    pending_approval_part1_message: 'Ihre Zugriffsanfrage wartet auf Genehmigung.',
    pending_approval_part2_message: 'Bitte besuchen Sie uns später für den Zugang.',
    submit: 'Absenden',
  },
  user_list: {
    name: 'Vollständiger Name',
    email: 'E-Mail',
    location: 'Standort',
    role: 'Rolle',
    last_login: 'Letzte Anmeldung'
  },
  users: {
    approved: 'Genehmigt',
    approved_description: 'Die Liste der genehmigten Benutzer. Diese Benutzer haben vollen Zugriff auf DIJ.',
    pending_approval: 'Ausstehende Genehmigung',
    pending_approval_description: 'Die Liste der zu genehmigenden Benutzer. Diese Benutzer können nicht auf DIJ zugreifen, bis ihr Profil genehmigt wurde.',
    todays_logins: 'Heutige Anmeldungen',
    todays_logins_description: 'Die Liste der Benutzer, die sich heute angemeldet haben. Wird täglich um Mitternacht zurückgesetzt.',
    rejected: 'Abgelehnt',
    rejected_description: 'Die Liste der Benutzer, die im Genehmigungsprozess abgelehnt wurden. Diese Benutzer wissen nicht, dass sie abgelehnt wurden.',
    inactive: 'Inaktiv',
    inactive_description: 'Die Liste der Benutzer, die keine SEPIA-Informationen an ihrem Konto haben.',
  },
  user_picker: {
    label: 'Benutzer auswählen',
    placeholder: 'Eingeben und verfügbare Benutzer auswählen',
    no_match_found: 'Keine Übereinstimmung gefunden',
    email: 'E-Mail',
    role: 'Rolle'
  },

  sign_off_instruction_not_completed: 'Einige Anweisungen in der Aufgabe wurden nicht vollständig abgeschlossen. Sind Sie sicher, dass Sie die Aufgabe abzeichnen möchten? Dadurch wird die Aufgabe für zukünftige Änderungen gesperrt.',
  sign_off_diagram_not_completed: 'Einige Prüfpunkte in der Aufgabe wurden nicht abgeschlossen. Sind Sie sicher, dass Sie die Aufgabe abzeichnen möchten? Dadurch wird die Aufgabe für zukünftige Änderungen gesperrt.',

  chat_box: {
    generated_content_warning: 'Inhalte werden automatisch von KI generiert und können Ungenauigkeiten enthalten',
    type_message_placeholder: 'Nachricht eingeben...',
    send: 'Senden',
    regenerate: 'Neu generieren',
    please_wait: 'Bitte warten...',
    clear_local_history: 'Lokalen Verlauf löschen',
    click_to_copy: 'Zum Kopieren klicken',
    returning_answer: 'Antwort wird zurückgegeben...',
    summary_generated: 'Zusammenfassung generiert!',
  },
  report_template: {
    project_title: 'Projekttitel',
    enter_project_number: 'Projektnummer eingeben',
    customer: 'Kunde',
    enter_customer_information: 'Kundeninformationen eingeben',
    customer_tag: 'Kundenkennzeichen',
    enter_customer_tag: 'Kundenkennzeichen eingeben',
    customer_po_no: 'Kunden-Bestellnummer',
    unit_serial: 'Einheitenseriennummer',
    enter_serial_info: 'Serieninformationen eingeben',
    unit_model: 'Einheitenmodell',
    project_number: 'Projektnummer',
    sales_force_opportunity_number: 'Sales Force Opportunity-Nummer',
    enter_sales_force_opportunity_number: 'Sales Force Opportunity-Nummer eingeben',
    process: 'Prozess',
    enter_process: 'Prozess eingeben',
    original_order_no: 'Ursprüngliche Auftragsnr.',
    enter_original_order_no: 'Ursprüngliche Auftragsnr. eingeben',
    previous_orders: 'Vorherige Aufträge',
    enter_previous_orders: 'Vorherige Aufträge eingeben',
    contact_person_name: 'Name der Kontaktperson',
    enter_contact_person_name: 'Name der Kontaktperson eingeben',
    contact_person_department: 'Abteilung der Kontaktperson',
    executive_summary: 'Zusammenfassung',
    generate_executive_summary: 'Zusammenfassung generieren',
    repair_select: 'Repair Select',
    sample_text: 'Beispieltext:',
    sample_text_content: 'Siemens erbrachte technische Dienstleistungen im Auftrag von Duke Energy Carolinas LLC zur Inspektion und Beratung von Reparaturempfehlungen für eine EMM32A3N-Rotoranordnung. Die Rotoranordnung wurde zur Eingangsinspektion an das Siemens-Reparaturwerk in Charlotte, North Carolina, geschickt.',
    revision_description: 'Revisionsbeschreibung',
    enter_revision_description: 'Revisionsbeschreibung eingeben',
    csm: 'CSM',
    enter_csm: 'CSM eingeben',
    repair_engineer: 'Reparaturingenieur',
    enter_repair_engineer: 'Reparaturingenieur eingeben',
    major_components: 'Hauptkomponenten',
    minor_components: 'Unterkomponenten',
    work_performed_fact_finding: 'Durchgeführte Arbeiten für die Befundungsinspektion',
    work_performed_repair: 'Durchgeführte Arbeiten für die Reparatur',
    repairs_not_completed_recommendations_upgrades: 'Nicht abgeschlossene Reparaturen, Empfehlungen und Upgrades',
    appendix: 'Anhang',
  },

  report_header: {
    internal_report: 'Interner Bericht',
    customer_report: 'Kundenbericht',
    exclude_items: 'Elemente ausschließen',
    documents: 'Dokumente',
    revisions: 'Revisionen',
    description: 'Beschreibung: {description}',
    download: 'Herunterladen',
    header: 'Kopfzeile',
    deviation_report: 'Abweichungsbericht',
    repair_assessment: 'Reparaturbewertung',
    work_performed: 'Durchgeführte Arbeiten',
    deleting_report_revision: 'Berichtsrevision wird gelöscht',
    delete_revision_confirmation: 'Sind Sie sicher, dass Sie die Revision <b>{fileName}</b>, Beschreibung: {description} <b>löschen</b> möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    delete_revision: 'Revision löschen',
  },

  report_tasks: {
    table: 'TABELLE',
    form_inspection: 'FORMULARINSPEKTION',
    document_number: 'Dokumentnummer:',
    revision: 'Revision:',
    no_records: 'Keine Einträge',
    item: 'POSITION',
    answer: 'ANTWORT',
    attachments_uc: 'ANHANG/ANHÄNGE',
    inspector: 'INSPEKTOR',
    date: 'DATUM',
    inspection_diagram: 'INSPEKTIONSDIAGRAMM',
    length_measurements: 'LÄNGENMESSUNGEN',
    diameter_measurements: 'DURCHMESSERMESSUNGEN',
    visual_inspection: 'SICHTPRÜFUNG',
    generic_measurements: 'ALLGEMEINE MESSUNGEN',
    label_uc: 'Bezeichnung',
    part_name_uc: 'Teilename',
    description_uc: 'Beschreibung',
    question_label: 'Frage:',
    name_label: 'Name:',
    description_label: 'Beschreibung:',
    expected_value_uc: 'Erwarteter Wert',
    tolerance1: 'Toleranz1',
    tolerance2: 'Toleranz2',
    unit: 'Einheit',
    inspector_title: 'Inspektor',
    date_title: 'Datum',
    condition: 'Zustand',
    severity: 'Schweregrad',
    measurement_name_uc: 'Messungsname',
    runout_measurements: 'RUNDLAUFMESSUNGEN',
    tir: 'TIR',
    tolerance: 'Toleranz',
    task_prefix: 'Aufgabe:',
    show_oot_colors: 'Außerhalb-Toleranz-Farben anzeigen',
    free_finding: 'FREIER BEFUND',
    attachments_plain: 'ANHÄNGE',
    pictures: 'Bilder',
    excluded: 'ausgeschlossen',
  },

  deviation_report: {
    unit_serial: 'Einheitenseriennummer:',
    review_only: 'Nur zur Überprüfung',
    action_required: 'Aktion erforderlich',
    assembly_bom: 'Baugruppen-Stückliste',
    assembly_ref: 'Baugruppen-Referenz',
    item_number: 'Position #',
    original_pn: 'Ursprüngliche PN',
    actions: 'Aktionen',
  },

  external_data: {
    title: 'EXTERNE DATEN',
    upload_failed: 'Datei-Upload fehlgeschlagen',
    item_uc: 'POSITION',
    file_name: 'Dateiname',
    print_to_report: 'Im Bericht drucken',
    file_type_error: 'Dieser Dateityp kann nicht im Bericht gedruckt werden',
    delete: 'Löschen',
    too_many_attachments: 'Zu viele Anhänge. Maximal erlaubt sind {max} Anhänge.',
    upload_successful: 'Anhang erfolgreich hochgeladen.',
  },

  viewer_3d: {
    downloading_file: 'Datei wird heruntergeladen...',
    loading_file: 'Datei wird geladen...',
    screenshot: 'Screenshot',
    select_task_screenshot: 'Eine Aufgabe auswählen, um den Screenshot zu speichern:',
  },

  findings: {
    title: 'BEFUNDE',
    by_inspector: 'Vom Inspektor',
    by_reporter: 'Vom Berichterstatter',
    placeholder: 'Bitte geben Sie hier Ihre Befunde ein...',
  },

  close_message: 'Nachricht schließen',
  close_banner: 'Banner schließen',
  other: 'Andere',
  enter_an_option: 'Option eingeben',
  tap_to_start_writing: 'Klicken Sie hier, um zu schreiben',
  breadcrumbs: 'Brotkrümel',
  close: 'Schließen',

  diagram_builder: {
    repair_icon: 'Reparatursymbol',
    bubble_processing: 'Blase wird noch verarbeitet',
    import_diagram: 'Diagramm importieren',
    choose_files: 'Dateien auswählen',
    note_runout_points_missing: 'Hinweis: Das Diagramm enthält nicht alle Rundlaufpunkte aus der Datei.',
    note_points_missing: 'Hinweis: Das Diagramm enthält nicht alle Punkte aus der Datei.',
    laserscan_import_success: 'LaserScan-Werte erfolgreich importiert.',
    not_all_dij_points_filled: 'Hinweis: Nicht alle DIJ-Punkte wurden ausgefüllt.',
    all_inspection_values_imported_successfully: 'Alle Inspektionswerte wurden erfolgreich importiert.',
    image_size: 'Bildgröße',
    edit_comment: 'Kommentar bearbeiten',
    comment: 'Kommentar',
    your_comment: 'Ihr Kommentar',
    fine: 'In Ordnung',
    major_component: 'Hauptkomponente',
    minor_component: 'Unterkomponenten',
    label: 'Bezeichnung',
    expected: 'Erw.',
    tolerance: 'Tol.',
    empty_diagram: 'Leeres Diagramm',
    take_photo: 'Foto aufnehmen',
    tir: 'TIR',
    position_image: 'Bild positionieren',
    description_options: {
      other: 'Andere',
      te_bearing_journal: 'TE-Lagerstelle',
      nte_bearing_journal: 'NTE-Lagerstelle',
      te_seal_fit: 'TE-Dichtungssitz',
      nte_seal_fit: 'NTE-Dichtungssitz',
      coupling_fit: 'Kupplungssitz',
      probe_track: 'Sondenspur',
      bridgeover: 'Überbrückung',
      thrust_disc_fit: 'Axiallagersitz',
      balance_piston: 'Ausgleichskolben',
      overspeed_trip_fit: 'Keyphasor',
      te_gland: 'TE-Stopfbuchse',
      nte_gland: 'NTE-Stopfbuchse',
      '1st_stg_impeller_eye': '1. Stufe Laufradauge',
      '2nd_stg_impeller_eye': '2. Stufe Laufradauge',
      '3rd_stg_impeller_eye': '3. Stufe Laufradauge',
      '4th_stg_impeller_eye': '4. Stufe Laufradauge',
      '5th_stg_impeller_eye': '5. Stufe Laufradauge',
      '6th_stg_impeller_eye': '6. Stufe Laufradauge',
      '7th_stg_impeller_eye': '7. Stufe Laufradauge',
      '8th_stg_impeller_eye': '8. Stufe Laufradauge',
      '1st_2nd_stg_spacer': '1.-2. Stufe Abstandshalter',
      '2nd_3rd_stg_spacer': '2.-3. Stufe Abstandshalter',
      '3rd_4th_stg_spacer': '3.-4. Stufe Abstandshalter',
      '4th_5th_stg_spacer': '4.-5. Stufe Abstandshalter',
      '5th_6th_stg_spacer': '5.-6. Stufe Abstandshalter',
      '6th_7th_stg_spacer': '6.-7. Stufe Abstandshalter',
      '7th_8th_stg_spacer': '7.-8. Stufe Abstandshalter',
      journal_area_te: 'Lagerstelle TE',
      journal_area_nte: 'Lagerstelle NTE',
      thrust_collar_fit: 'Axiallagersitz',
      center_balance_plane: 'Zentrale Auswuchtebene',
      rh_cplg_tpr_fit: 'RH-Kupplungskegelpassung',
      lh_cplg_tpr_fit: 'LH-Kupplungskegelpassung',
      extension_fit_te: 'Verlängerungspassung TE',
      extension_fit_nte: 'Verlängerungspassung NTE',
      exciter_fit: 'Erregersitz',
      fan_fit_te: 'Lüftersitz TE',
      fan_fit_nte: 'Lüftersitz NTE',
      dummy_piston_fit: 'Blindkolbensitz',
      oil_deflector_fit_te: 'Ölabweisersitz TE',
      oil_deflector_fit_nte: 'Ölabweisersitz NTE',
      hydrogen_seal_fit_te: 'Wasserstoffdichtungssitz TE',
      hydrogen_seal_fit_nte: 'Wasserstoffdichtungssitz NTE',
      collector_ring_fit_te: 'Schleifringpassung TE',
      collector_ring_fit_nte: 'Schleifringpassung NTE',
      te_brg_seal_area: 'TE-Lagerdichtungsbereich',
      nte_brg_seal_area: 'NTE-Lagerdichtungsbereich',
      thrust_runner_fit: 'Axialläufersitz',
    },
  },

  admin_page: {
    create_new_role: 'Neue Rolle erstellen',
    new_role_name: 'Neuer Rollenname',
    select_software_tools: 'Softwarewerkzeuge auswählen',
    edit_role: 'Rolle bearbeiten',
    delete: 'Löschen',
    update: 'Aktualisieren',
    cancel: 'Abbrechen',
    save: 'Speichern',
    edit: 'Bearbeiten',
    features: "Funktionen",
    role: "Rolle",
    role_name: "Rollenname",
    add_role: "Rolle hinzufügen",
    add_site: "Standort hinzufügen",
    add_mte_type: "MTE-Typ hinzufügen",
    needs_master: "Benötigt Master",
    is_master: "Ist Master",
    filter: "Filter",
    search: "Suchen...",
    all: "Alle",
    fixes: "Korrekturen",
    removals: "Entfernungen",
    permitted_tools: "Erlaubte Werkzeuge",
    date_modified: "Änderungsdatum",
    user: "Benutzer",
    sites: "Standorte",
    mte_types: "MTE-Typen",
    notification_banner: "Benachrichtigungsbanner",
    next: "Weiter",
    back: "Zurück",
    create_role: "Rolle erstellen",
    default_role_error: "Entschuldigung, Sie können Standardrollen nicht ändern.",
    success_default: "Aktion erfolgreich abgeschlossen.",
    failed_default: "Aktion fehlgeschlagen. Bitte erneut versuchen.",
    instrumentation: 'Instrumentierung',
    add_instrumentation: 'Instrumentierung hinzufügen',
  },

  conflict: {
    title: 'Versionskonflikte erkannt',
    yours: 'Ihre Version',
    theirs: 'Andere Version',
    done: 'Fertig',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    use_mine_all: 'Meine Version für alle verwenden',
    use_theirs_all: 'Andere Version für alle verwenden',
    img_reference: 'Bildreferenz',
    keep_mine: 'Meine Version behalten',
    use_theirs: 'Andere Version verwenden',
    unknown: 'Unbekannt',
    last_changed_by: 'Zuletzt geändert von:',
  },

  instruction_view: {
    create_new: 'Neu erstellen',
    create_sub_instruction: 'Neue Unteranweisung erstellen',
    table_image_alt: 'Tabellenbild',
    image_alt: 'Bild',
    add_option: 'Option hinzufügen',
    add_other_option: '"Andere" Option hinzufügen',
    manage_options: 'Optionen verwalten',
    use_image_reference: 'Bild als Aufgabenreferenz verwenden',
    upload_image: 'Bild hochladen',
    upload_image_alt: 'Tabellenbild',
    uploading: 'Wird hochgeladen...',
    choose_one_item: 'Ein Element auswählen',
    take_photo: 'Foto aufnehmen',
    choose_file: 'Datei auswählen',
    question: 'Frage',
    import: 'Importieren',
    table: 'Tabelle',
    rows: 'Zeilen',
    columns: 'Spalten',
    csv_import_note: 'Hinweis: Die Spaltenüberschriften sollten sich in der ersten Zeile der CSV-Datei befinden. Der Import funktioniert nur für CSV-Dateien, nicht für Excel-Dateien.',
    action_option: 'Aktion',
    yes_no_option: 'Ja/Nein',
    multiple_choice_option: 'Mehrfachauswahl',
    single_choice_option: 'Einzelauswahl',
    text_number_option: 'Text',
    table_option: 'Tabelle',
    smart_table_option: 'Intelligente Tabelle',
    import_csv_option: 'CSV-Tabelle importieren',
    done: 'Fertig',
  },

  shared: {
    loading: 'Wird geladen...',
    no_records: 'Keine Einträge',
    submit: 'Absenden',
    finish: 'Abschließen',
    select_everything: 'Alles auswählen',
    deselect_everything: 'Alles abwählen',
    warning: 'Warnung',
    tasks: 'Aufgaben',
    task: 'Aufgabe',
    all: 'Alle',
    status: 'Status',
    signed_off_by: 'Abgezeichnet von',
    signed_off_at: 'Abgezeichnet am',
    percent_complete: '% Abgeschlossen',
    tool_bar: 'Werkzeugleiste',
    id: 'ID',
    major_components: 'Hauptkomponenten',
    minor_components: 'Unterkomponenten',
    generated_repair_recommendations: 'Reparaturempfehlungen für dieses Teil generieren',
    summarize_repair_recommendations: 'Reparaturempfehlungen zusammenfassen',
    shop_notes: 'Werkstattnotizen',
    serial_number: 'Seriennummer',
    helpers: 'Helfer',
    saved: 'Gespeichert',
    close: 'Schließen',
    documents: 'Dokumente',
    upload_attachments: 'Anhänge hochladen',
    download: 'Herunterladen',
    upload: 'Hochladen',
    leadman_sign_off_required: 'Abzeichnung des Vorarbeiters erforderlich',
    require_leadman_signing: 'Unterschrift des Vorarbeiters erforderlich',
    chat_with_rs: 'Mit Repair Select chatten',
    status_complete: 'Abgeschlossen',
    status_open: 'Offen',
  },

  version_page: {
    dij_releases: "DIJ-Versionen",
    features: "Funktionen",
    fixes: "Korrekturen",
    removals: "Entfernungen",
    improvements: "Verbesserungen",
    hotfix: "Hotfix",
    updates: "Aktualisierungen",
    version: "Version",
    date: "Datum",
    tag: "Tag"
  },
  common: {
    close: "Schließen",
    save: "Speichern",
    uploading_progress: "Hochladen {uploaded}/{total}"
  },
  version_form: {
    title: "Neue Version hinzufügen",
    version: "Version",
    date: "Datum",
    date_placeholder: "Klicken Sie, um ein Datum auszuwählen",
    section: "Abschnitt",
    section_placeholder: "Abschnitt auswählen",
    details: "Details",
    tag: "Tag"
  },
  file_explorer: {
    select_all: 'Alle auswählen',
    recycle_bin: 'Papierkorb',
    image_gallery: 'Bildergalerie',
    exclude_images: 'Bilder ausschließen',
    include_images: 'Bilder einschließen',
    attach_images: 'Bilder anhängen',
    restore_file: 'Datei wiederherstellen',
    root: 'Stammverzeichnis (/)'
  },

  work_instructions: 'Arbeitsanweisungen',
  add_work_instruction: 'Arbeitsanweisung hinzufügen',
  create_work_instruction: 'Arbeitsanweisung erstellen',
  select_work_instruction_package: 'Arbeitsanweisungspaket auswählen',
  work_instruction_title: 'Arbeitstitel',
  disabled_wi_signoff:'Alle verknüpften Aufgaben müssen abgezeichnet werden, bevor die Arbeitsanweisung abgezeichnet werden kann.'
};

export default de;